import { localizeHref } from '@/paraglide/runtime';

type Props = {
  statusCode: number;
};

export function ErrorSection(props: Props) {
  const { statusCode } = props;
  return (
    <section className='mt-16 flex min-h-[calc(100vh-661px)] items-center bg-white'>
      <div className='mx-auto max-w-(--breakpoint-xl) px-4 py-8 lg:px-6 lg:py-16'>
        <div className='mx-auto text-center'>
          <h1 className='mb-4 text-7xl font-extrabold tracking-tight text-azure-455 lg:text-9xl'>
            {statusCode}
          </h1>
          <p className='mb-4 text-3xl font-bold tracking-tight md:text-4xl'>
            Whoops! That page doesn’t exist.
          </p>
          <p className='mx-auto mb-4 max-w-[500px] text-lg font-light text-neutral-770'>
            Sorry, we can't find that page. You'll find lots to explore on the
            home page.
          </p>
          <a
            className='inline-block cursor-pointer rounded-full border-0 bg-azure-455 p-4 text-center text-[14px] leading-[18px] font-[600] text-neutral-50 no-underline sm:px-8 sm:py-3 sm:text-[18px] sm:leading-[24px]'
            href={localizeHref('/')}
          >
            Back to Homepage
          </a>
        </div>
      </div>
    </section>
  );
}
